import { Component, Input } from '@angular/core';
import { Ticket, TicketRecordType } from 'src/app/models/ticket/ticket.model';

@Component({
    selector: 'app-ticket-detail-service',
    templateUrl: './ticket-detail-service.component.html',
    styleUrls: ['./ticket-detail-service.component.scss'],
    standalone: false
})
export class TicketDetailServiceComponent {
  @Input() ticket: Ticket;

  @Input() browserSize: string;

  TicketRecordType = TicketRecordType;
}
